import { ReactNode } from 'react';

import { Box, Container, Flex } from '../Layout';
import { Text } from '../Text';
import { Colors } from '../../utils';
import { CircleCheckmarkOutlined, CircleInfoIcon, TriangleExclamationIcon } from '../../assets/icons';

type FeedbackProps = {
  /** Background color and icon*/
  type: 'error' | 'information' | 'confirmation' | 'warning';
  /** Negative side margins, like WideBox and SpeechBubble */
  negativeSideMargins?: boolean;
  /** Side padding. wide 40px - slim 20px  (always 20 on mobile) */
  size?: 'wide' | 'slim';
  /** Default is icon on the left */
  iconAbove?: boolean;
  marginTop?: number;
  marginBottom?: number;
  children: ReactNode;
  testId?: string;
};

export const Feedback = ({
  type,
  negativeSideMargins = false,
  iconAbove = false,
  size = 'wide',
  marginTop,
  marginBottom,
  children,
  testId,
}: FeedbackProps) => {
  const sideSpace = size === 'slim' ? 20 : 40;
  const sideMargins = negativeSideMargins ? [-20, -sideSpace, -sideSpace] : undefined;
  return (
    <Box
      backgroundColor={colorMap[type]}
      paddingTop={20}
      paddingBottom={20}
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginRight={sideMargins}
      marginLeft={sideMargins}
      paddingRight={[20, sideSpace, sideSpace]}
      paddingLeft={[20, sideSpace, sideSpace]}
      position="relative"
      data-testid={testId}
    >
      {iconAbove ? (
        <Flex flexDirection="column" rowGap={6} alignItems="flex-start">
          <Icon type={type} />
          {typeof children === 'string' ? <Text size="small">{children}</Text> : <Container>{children}</Container>}
        </Flex>
      ) : (
        <Flex alignItems="center" columnGap={20}>
          <Icon type={type} />
          {typeof children === 'string' ? <Text size="small">{children}</Text> : <Container>{children}</Container>}
        </Flex>
      )}
    </Box>
  );
};

const colorMap: { [key in FeedbackProps['type']]: Colors } = {
  error: 'babyPink',
  warning: 'babyYellow',
  confirmation: 'babyGreen',
  information: 'babyBlue',
};
const Icon = ({ type }: { type: FeedbackProps['type'] }) => {
  switch (type) {
    case 'error':
      return <CircleInfoIcon width={22} />;
    case 'information':
      return <CircleInfoIcon width={22} />;
    case 'warning':
      return <TriangleExclamationIcon width={22} />;
    case 'confirmation':
      return <CircleCheckmarkOutlined width={22} />;
  }
};
